// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../scout/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sticky-top-bar.on-top[data-v-7b90efc1]{background-color:#fff}.sticky-top-bar.on-top .sticky-top-bar__background[data-v-7b90efc1]{top:-1px;height:100%;position:absolute;background-color:#fff;width:100%;z-index:-1;box-shadow:10px 6px 12px rgba(0,0,0,.059);border:1px solid #ccc;box-sizing:border-box}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
